module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_text.1789440611829.png";